
import { canonical } from "@utils";
export default {
	name: "AppPrivacyPolicy",
	head() {
		return {
			link: [canonical(this.$route)],
		};
	},
	methods: {
		onOneTrustLinkClick(event) {
			const OTLink = document.getElementById("ot-sdk-btn");
			if (OTLink) {
				OTLink.click();
			}
		},
	},
};
